// Export Functions

function getEndpointDomain() {
  let url;
  if (window.location.hostname.includes('.local')) {
    url = '//dev.macpac.local';
  } else {
    if (window.location.hostname.includes('dev.')) {
      url = '//www.test1.goldwin.co.jp';
    } else {
      url = '//www.goldwin.co.jp';
    }
  }
  return url;
}


// function toggleBrandList() {
//   const toggleButton = document.querySelector('.js-brand-btn');
//   if (toggleButton === undefined) return;

//   // toggleButton のON/OFFをtoggle処理する
//   toggleButton.addEventListener('click', () => {
//     // toggleButton の次の要素を取得
//     const target = toggleButton.nextElementSibling;
//     target.style.display = target.style.display === 'block' ? 'none' : 'block';
//   });

//   // console.debug(toggleButton);
// }

// function toggleMegaMenu() {
//   const toggleMenus = document.querySelectorAll('.js-nav-open');
//   if (toggleMenus === undefined) return;

//   toggleMenus.forEach((toggleMenu) => {
//     //toggleMenu の親要素を指定
//     const parentMenu = toggleMenu.parentElement;
//     const childMenuSet = parentMenu.children;

//     //parentMenu にマウスのオンオフした時の処理
//     parentMenu.addEventListener('mouseenter', () => {
//       childMenuSet[0].classList.add('open');
//       childMenuSet[1].classList.add('open');
//     });
//     parentMenu.addEventListener('mouseleave', () => {
//       childMenuSet[0].classList.remove('open');
//       childMenuSet[1].classList.remove('open');
//     });
//   });
// }

function init() {
  getEndpointDomain();
  // changeSiteDeviceType();
  // // ヘッダーとフッターの共通処理
  // toggleMegaMenu();
  // toggleBrandList();
}

// var startPos = 0;
// window.addEventListener('scroll', function (e) {
//   winScrollTop = window.pageYOffset;
//   winHeight = window.innerHeight;

//   if (winScrollTop > 1) {
//     document.body.dataset.scroll = 'scrolled';
//     document.querySelector('.header-wrap').classList.add('fixed');
//     // document.querySelector('.js-local-nav').style.top = '70';
//   } else {
//     document.body.dataset.scroll = 'unscroll';
//     document.querySelector('.header-wrap').classList.remove('fixed');
//     // document.querySelector('.js-local-nav').style.top = '140';
//   }

//   startPos = winScrollTop;
//   return false;
// });

document.addEventListener('DOMContentLoaded', init);
